import { CANDY_APPLE, KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import EnrollmentConversionToggle from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionToggle';
import HistoryPanelHeaderWithLink from 'automation-ui-canvas/containers/enrollment-history/panel/HistoryPanelHeaderWithLink';
import VersionAndDateFilterSection from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/VersionAndDateFilterSection';
import { getEnrollmentHistoryListUrl, getMetricsUrl } from 'automation-ui-canvas/utils/urls';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIPanelSection = styled(UIPanelSection).withConfig({
  displayName: "EnrollmentConversionFiltersSection__StyledUIPanelSection",
  componentId: "sc-19tgisf-0"
})(["background-color:", ";"], KOALA);
const EnrollmentConversionFiltersSection = ({
  flowId,
  reportEnabledTimeStamp,
  isReportingEnabled,
  setReportingEnabled,
  limit,
  enabledCount,
  isEnablementRecommended,
  shouldAllowEnablement,
  errorMessage
}) => {
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  const handleClearFilters = useCallback(() => {
    trackEvent(Trackables.AGGREGATE_PERFORMANCE_RESET_FILTERS);
    history.replace({
      pathname: getMetricsUrl({
        flowId
      }),
      search: '?showVersions=true'
    });
  }, [flowId, history, trackEvent]);
  const navigateToEnrollmentsList = () => {
    trackEvent(Trackables.AGGREGATE_PERFORMANCE_VIEW_ENROLLMENT_HISTORY);
    history.push({
      pathname: getEnrollmentHistoryListUrl({
        flowId
      }),
      search: searchParams.toString()
    });
  };
  return /*#__PURE__*/_jsxs(StyledUIPanelSection, {
    className: "p-all-5 m-bottom-0",
    children: [/*#__PURE__*/_jsx(HistoryPanelHeaderWithLink, {
      titleKey: "automation.enrollmentConversion.panel.header.title",
      navigationLinkKey: "automation.enrollmentConversion.panel.header.navigationLink",
      navigationLinkClickHandler: () => navigateToEnrollmentsList(),
      navigationDirection: "right"
    }), /*#__PURE__*/_jsx(EnrollmentConversionToggle, {
      isReportingEnabled: isReportingEnabled,
      setReportingEnabled: setReportingEnabled,
      limit: limit,
      enabledCount: enabledCount,
      isEnablementRecommended: isEnablementRecommended,
      shouldAllowEnablement: shouldAllowEnablement,
      errorMessage: errorMessage
    }), /*#__PURE__*/_jsx(VersionAndDateFilterSection, {
      flowId: flowId,
      page: "workflow-metrics"
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      align: "center",
      className: "p-top-1 m-right-1",
      children: [(timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp) && (timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp) < reportEnabledTimeStamp && /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation.enrollmentConversion.panel.warning.tooltip",
          options: {
            metricsEnabledTime: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
              value: reportEnabledTimeStamp,
              format: `llll z`
            })
          }
        }),
        children: /*#__PURE__*/_jsxs(UIFlex, {
          direction: "row",
          style: {
            color: CANDY_APPLE
          },
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.warning.text"
          }), /*#__PURE__*/_jsx(UIIcon, {
            className: "m-left-1",
            name: "info"
          })]
        })
      }), /*#__PURE__*/_jsx(UIFlex, {
        justify: "end",
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: () => {
            handleClearFilters();
          },
          "data-test-id": "enrollment-conversion-clear-filters",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.filters.resetFilters"
          })
        })
      })]
    })]
  });
};
export default EnrollmentConversionFiltersSection;